import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Link from '../../components/common/Link';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import * as AdsActionCreators from '../../redux/homepageAds';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';
import { startCase } from 'lodash';
import moment from 'moment';

import Empty from '../../components/common/Empty';
import { SHOWING_FIELDS_ADS } from '../../constants';

const TableContainer = styled.div`
  background-color: #eeeeee;
  padding: 20px;
`;

const TablePaper = styled(Paper)`
  && {
    width: 100%;
    margin-top: 30px;
    overflow-x: auto;
  }
`;

const OrganizationsTable = styled(Table)`
  && {
    min-width: 700px;
  }
`;

const OrganizationsTableHead = styled(TableHead)`
  && {
    background-color: rgba(125, 188, 255, 0.6);
  }
`;

const OrganizationsTableHeadFields = styled(TableCell)`
  && {
    color: black;
    font-weight: bold;
  }
`;

const EditButtonContainer = styled.div`
  margin-top: 5px;
`;

class AdsPage extends Component {
  state = {
    showOnHomePage: false,
    linkField: '',
    descriptionField: '',
    orderField: 1
  };

  componentDidMount() {
    const { actions } = this.props;
    actions.getAds();
  }
  uploadAd() {
    const { actions } = this.props;
    actions.createAd({
      order: this.state.orderField,
      link: this.state.linkField,
      description: this.state.descriptionField,
      archive: !this.state.showOnHomePage
    });
  }
  getCellNames = () => {
    return ['order', 'link', 'description', 'active', 'actions'];
  };

  onChangeSwitch = fieldName => (e, checked) =>
    this.setState({ [fieldName]: checked });

  onChangeLinkUrl = value => this.setState({ linkField: value });

  onChangeDescription = value => this.setState({ descriptionField: value });

  onChangeOrder = value => this.setState({ orderField: value });

  renderTableCellNames = () => {
    const cellNames = this.getCellNames();
    return cellNames.map((name, i) => {
      if (SHOWING_FIELDS_ADS.includes(name)) {
        const displayName = startCase(name);

        return (
          <OrganizationsTableHeadFields key={i}>
            {displayName}
          </OrganizationsTableHeadFields>
        );
      }
      return null;
    });
  };

  renderTableBody = () => {
    const { ads } = this.props;

    if (!ads) return <TableRow />;

    const cellNames = this.getCellNames();
    return ads.map((ad, i) => {
      return (
        <TableRow key={i}>
          {cellNames.map((field, index) => {
            let value;
            if (field === 'created_at') {
              value = moment(ad[field]).format('LLLL');
            } else if (typeof ad[field] === 'boolean') {
              value = ad[field].toString();
            } else if (field === 'actions') {
              return (
                <TableCell key={index}>
                  <EditButtonContainer>
                    <Link to={`/ads/edit/${ad.id}`}>
                      <Button variant="outlined" color="primary">
                        Edit
                      </Button>
                    </Link>
                  </EditButtonContainer>
                </TableCell>
              );
            } else if (field === 'active') {
              if (!ad['archived']) {
                value = 'Yes';
              } else {
                value = 'No';
              }
            } else {
              value = ad[field];
            }
            return <TableCell key={index}>{value}</TableCell>;
          })}
        </TableRow>
      );
    });
  };

  renderTable = () => {
    const { ui } = this.props;
    if (ui === 'complete') {
      return (
        <OrganizationsTable>
          <OrganizationsTableHead>
            <TableRow>{this.renderTableCellNames()}</TableRow>
          </OrganizationsTableHead>
          <TableBody>{this.renderTableBody()}</TableBody>
        </OrganizationsTable>
      );
    }

    return null;
  };

  renderEmpty = () => (this.props.ui === 'empty' ? <Empty /> : null);
  render() {
    return (
      <div>
        <Link to={`/ads/new`}>
          <Button variant="outlined" color="primary">
            Create New
          </Button>
        </Link>
        <TableContainer>
          <TablePaper>
            {this.renderTable()}
            {this.renderEmpty()}
          </TablePaper>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ads: state.homepageAds.ads,
    ad: state.homepageAds.ad,
    ui: state.ui.uiState
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AdsActionCreators, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdsPage)
);



// WEBPACK FOOTER //
// ./src/pages/ads/index.js